import {
  QUICK_FIND_SET_DROPDOWN_OPEN,
  QUICK_FIND_SET_SELECTED,
  QUICK_FIND_SET_COLUMN_OPEN,
  QUICK_FIND_SET_COLUMN_OPTIONS,
  QUICK_FIND_RESET,
} from '../reducers/quickFind';

export const setDropdownOpen = (open = true) => ({
  type: QUICK_FIND_SET_DROPDOWN_OPEN,
  data: { open },
});

export const setSelected = (column, selected) => ({
  type: QUICK_FIND_SET_SELECTED,
  data: { column, selected },
});

export const setColumnOpen = (column, open = true) => ({
  type: QUICK_FIND_SET_COLUMN_OPEN,
  data: { column, open },
});

export const setColumnOptions = (column, options = []) => ({
  type: QUICK_FIND_SET_COLUMN_OPTIONS,
  data: { column, options },
});

export const quickFindReset = () => ({
  type: QUICK_FIND_RESET,
});
